import { createSelector, createStructuredSelector } from 'reselect';
import { dataDomain, loaderDomain, unsubscribeFormDomain } from './domains';

const initialDataSelect = createSelector(
  dataDomain,
  data => data
);

const isFormErrorSelect = createSelector(
  unsubscribeFormDomain,
  ({ error }) => error
);

const isFormLoadingSelect = createSelector(
  unsubscribeFormDomain,
  ({ isLoading }) => isLoading
);

const isFormSubmittedSelect = createSelector(
  unsubscribeFormDomain,
  ({ isLoaded }) => isLoaded
);

const localeSelect = createSelector(
  dataDomain,
  ({ locale }) => locale
);

const showLoaderSelect = createSelector(
  loaderDomain,
  loader => !!loader.length
);

const teslaUrlSelect = createSelector(
  dataDomain,
  ({ teslaUrl }) => teslaUrl
);

export default createStructuredSelector({
  initialData: initialDataSelect,
  isFormError: isFormErrorSelect,
  isFormLoading: isFormLoadingSelect,
  isFormSubmitted: isFormSubmittedSelect,
  locale: localeSelect,
  teslaUrl: teslaUrlSelect,
  showLoader: showLoaderSelect,
});
